import { render, staticRenderFns } from "./FaqComponent.vue?vue&type=template&id=5533eae0&"
import script from "./FaqComponent.vue?vue&type=script&lang=ts&"
export * from "./FaqComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports